import { AfterViewInit, ChangeDetectorRef, Component, Input, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

import { DEFAULT_PROGRESS, IProgress, LoadingProgressService } from '../../services/http-progress';
import { UiOptionsService } from '../../services/ui-options.service';

/** Component for showing metadata about the plot data */
@Component({
    selector: 'sci-loading-bar',
    templateUrl: './loading-bar.component.html',
    styles: [ `
        .loading-container, .error-container {
            padding: 16px;
            position: absolute;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
            z-index: 5;
            background: #fff;
        }

        .dark-theme {
            background: #424242;
            color: #fff;
        }

        .loading-container .mat-progress-bar {
            max-width: 80%;
        }
    ` ]
})
export class LoadingBarComponent implements AfterViewInit, OnDestroy {
    @Input() plotId: string;
    darkTheme: boolean;
    progress: IProgress = DEFAULT_PROGRESS;
    subscriptions: Subscription[] = [];
    numFinished = 0;
    totalTrackers = 0;

    constructor(
        private _loadingProgressService: LoadingProgressService,
        private _changeDetectorRef: ChangeDetectorRef,
        private _uiOptionsService: UiOptionsService
    ) {}

    ngAfterViewInit() {
        setTimeout( () => {
            this.subscriptions.push( this._loadingProgressService.getLoadingProgress$( this.plotId ).subscribe( progress => {
                this.progress = progress;
                this._changeDetectorRef.detectChanges();

                const trackers = this._loadingProgressService.getLoadingTrackers( this.plotId );
                this.totalTrackers = trackers.length;
                this.numFinished = 0;
                trackers.forEach( tracker => {
                    if ( tracker.progress.percent === 100 ) {
                        this.numFinished++;
                    }
                });
            }));

            this.subscriptions.push( this._uiOptionsService.getUiOptions$().subscribe( newOptions => {
                this.darkTheme = newOptions.darkTheme;
            }));
        });
    }

    ngOnDestroy() {
        this.subscriptions.forEach( sub => sub.unsubscribe() );
    }
}
